/* MultiButtonGroup is an aesthetically pleasing group of buttons,
 * which allows multiple buttons to be selected at the same time.
 *
 * The class requires these properties:
 *   buttons - an array of objects with keys:
 *     "value": this is the value returned when the button is selected
 *     "content": this is the JSX shown within the button, typically a string
 *         that gets rendered as the button's display text
 *     "title": this is the title-text shown on hover
 *   onChange - a function that is provided with an array of the updated
 *     values (which it then is responsible for updating)
 *
 * The class has these optional properties:
 *   values - an array of the initial values of the buttons selected.
 *
 * Requires stylesheets/perseus-admin-package/editor.less to look nice.
 */

var React = require('react');
var ReactDOM = require("react-dom");
var styles = require('./styles.js');
var css = require("aphrodite").css;

var MultiButtonGroup = React.createClass({
    displayName: 'MultiButtonGroup',

    propTypes: {
        values: React.PropTypes.arrayOf(React.PropTypes.any),
        buttons: React.PropTypes.arrayOf(React.PropTypes.shape({
            value: React.PropTypes.any.isRequired,
            content: React.PropTypes.node,
            title: React.PropTypes.string
        })).isRequired,
        onChange: React.PropTypes.func.isRequired,
        allowEmpty: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            values: [],
            allowEmpty: true
        };
    },

    focus: function focus() {
        ReactDOM.findDOMNode(this).focus();
        return true;
    },

    toggleSelect: function toggleSelect(newValue) {
        var values = (this.props.values || []).slice(0);
        var allowEmpty = this.props.allowEmpty;

        if (values.indexOf(newValue) >= 0 && (values.length > 1 || allowEmpty)) {
            // If the value is already selected, unselect it
            values.splice(values.indexOf(newValue), 1);
        } else {
            // Otherwise merge with other values and return
            if (values.indexOf(newValue) < 0) {
                values.push(newValue);
            }
        }

        this.props.onChange(values);
    },

    render: function render() {
        var _this = this;

        var values = this.props.values || [];
        var buttons = this.props.buttons.map(function (button, i) {
            var selected = values.indexOf(button.value) >= 0;
            return React.createElement(
                'button',
                { title: button.title,
                    type: 'button',
                    id: "" + i,
                    key: "" + i,
                    ref: "button" + i,
                    className: css(styles.button.buttonStyle, selected && styles.button.selectedStyle),
                    onClick: _this.toggleSelect.bind(_this, button.value)
                },
                button.content || "" + button.value
            );
        });

        var outerStyle = {
            display: 'inline-block'
        };
        return React.createElement(
            'div',
            { style: outerStyle },
            buttons
        );
    }
});

module.exports = MultiButtonGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-components/multi-button-group.jsx
 ** module id = 198
 ** module chunks = 0 2
 **/